export const UPLOAD_WIZARDS = {
  UPLOAD: 'upload',
  COMMIT: 'commit',
  CONFIRMATION: 'confirmation',
};
